import { Pipe, PipeTransform } from '@angular/core';
import { Material } from '../classes/material.class';
import { Planning } from '../classes/planning.class';
import { getMaterialProperty } from './material-property.pipe';

@Pipe({
    name: 'filterByEntityType',
})
export class FilterByEntityTypePipe implements PipeTransform {
    transform(
        value: Planning[],
        entityTypes: string[],
        search?: string,
        materialsById?: Map<number, Material>,
        projectManagerId?: number | null
    ): Planning[] {
        if (!value) {
            return value;
        }
        return value.filter(item => {
            if (projectManagerId != null && item.projectmanager !== projectManagerId) {
                return false;
            }
            if (item.mainPlanning && item.mainPlanning.entitytype_key) {
                const matchesEntityType =
                    !entityTypes?.length || entityTypes.includes(item.mainPlanning.entitytype_key);
                if (!search) {
                    return matchesEntityType;
                }
                const searchLower = search.toLowerCase().trim();
                const matchesSearch =
                    item.comment?.toLowerCase().includes(searchLower) ||
                    item.afas_project_id?.toLowerCase().includes(searchLower) ||
                    item.location?.toLowerCase().includes(searchLower) ||
                    item.projectmanager_user?.name?.toLowerCase().includes(searchLower) ||
                    item.project?.name?.toLowerCase().includes(searchLower) ||
                    (item.planning_materials ?? []).some((pm: { material_id: number }) =>
                        getMaterialProperty(materialsById?.get(pm.material_id), 'type')
                            .toLowerCase()
                            .includes(searchLower)
                    );

                return matchesEntityType && matchesSearch;
            }
            return false;
        });
    }
}
